module.exports = __webpack_public_path__ + "static/media/ArrowLeft.6a9314e2.svg";